import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal, Spin } from "antd";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";

const WarehouseAccessList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [itemsPerPage] = useState(10);

  const { sendRequest: getWarehouseAccess } = useHttp();

  const getData = () => {
    getWarehouseAccess(
      {
        url: "/api/warehousePermission/",
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, [getWarehouseAccess]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, warehousePermissonId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Warehouse Access detail?",
      onOk() {
        setDeleteLoading(true);
        deleteOperation(
          {
            url: `/api/warehousePermission/?orgId=${localStorage.getItem(
              "orgId"
            )}&warehousePermissonId=${warehousePermissonId}`,
            method: "DELETE",
          },
          (data) => {
            if (data.success) {
              toast.success(data.success);
              setDeleteLoading(false);
            }

            if (data.error) {
              toast.error(data.error);
              setDeleteLoading(false);
            }
            getData();
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
      // height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const[selectedWarehouseData,setSelectedWarehouseData]=useState([]);


  const openModal = (data) => {
    console.log(data);

    const Id = data.warehousePermissonId;

    getWarehouseAccess(
      {
        url: `/api/warehousePermission/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehousePermissonId=${Id}`,
      },
      (res) => {
        if (res) {
          console.log(res);

          setSelectedData(data);
          console.log(res.warehouseDetail);
          setSelectedWarehouseData(res.warehouseDetail);
        }
      }
    );

    setIsModalOpen(true);
  };
  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.employeeName.toLowerCase().includes(filetrtext) ||
        item.createdDate.toLowerCase().includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Warehouse Access{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Warehouse Access
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Date </th>
                            <th>Executive Name </th>

                            <th>View</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.createdDate.split(" ")[0]} </td>

                                <td>{x.employeeName}</td>

                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>

                                <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.update(x);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  {deleteLoading === x ? (
                                    <Spin />
                                  ) : (
                                    <button
                                      onClick={(e) =>
                                        handleDelete(e, x.warehousePermissonId)
                                      }
                                      className="btn"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title">
           Warehouse Access Details
          </h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>
        {selectedData && (
          <div className="">
            <div className="row">
              <p className="col-md-6">Employee Name: {selectedData.employeeName}</p>
              <p className="col-md-6">Employee Code: {selectedData.employeeCode}</p>
            </div>
            <div className="row">
              <p className="col-md-6">Department Name: {selectedData.departmentName}</p>
              <p className="col-md-6">
              Designation Name: {selectedData.designationName}
              </p>
            </div>
          
      

            <h5>Warehouse Access Details</h5>
            <table className="table table-sm table-bordered text-center">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Warehouse Name</th>

                  <th>Warehouse Code</th>
                </tr>
              </thead>
              <tbody>
                {selectedWarehouseData &&
                  selectedWarehouseData.map((itm, i) => {
                    return (
                      <tr key={i} className="cursor-pointer">
                        <td>{i + 1}</td>
                        <td>{itm.warehouseName}</td>
                        <td>{itm.warehouseCode}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default WarehouseAccessList;
